__turbopack_context__.v({
  "Avatar": "sJgfxG_Avatar",
  "Fallback": "sJgfxG_Fallback",
  "Image": "sJgfxG_Image",
  "closeButton": "sJgfxG_closeButton",
  "content": "sJgfxG_content",
  "desc": "sJgfxG_desc",
  "footer": "sJgfxG_footer",
  "list": "sJgfxG_list",
  "listItem": "sJgfxG_listItem",
  "lock": "sJgfxG_lock",
  "mainBtn": "sJgfxG_mainBtn",
  "modal": "sJgfxG_modal",
  "modalContent": "sJgfxG_modalContent",
  "name": "sJgfxG_name",
  "position": "sJgfxG_position",
  "primary": "sJgfxG_primary",
  "root": "sJgfxG_root",
  "secBtn": "sJgfxG_secBtn",
  "secondary": "sJgfxG_secondary",
  "sub": "sJgfxG_sub",
  "tabs": "sJgfxG_tabs",
  "time": "sJgfxG_time",
  "title": "sJgfxG_title",
});
